import { MyAnalytics } from 'graphql/types';

export enum SummaryHoursLabels {
  worked = 'time-entry-revision-group',
  scheduled = 'work-schedule',
  remaining = 'remaining'
}

export type TransformReturnType = {
  [SummaryHoursLabels.scheduled]: number;
  [SummaryHoursLabels.remaining]: number;
  [SummaryHoursLabels.worked]: number;
};

export function transformAnalyticsData(
  data: MyAnalytics | undefined
): TransformReturnType {
  const result = {
    [SummaryHoursLabels.scheduled]: 0,
    [SummaryHoursLabels.worked]: 0,
    [SummaryHoursLabels.remaining]: 0
  };
  if (!data) {
    return result;
  } else {
    const workHoursIndex = data.dimensions.findIndex(
      (i) => i.id === SummaryHoursLabels.worked
    );
    const scheduledHoursIndex = data.dimensions.findIndex(
      (i) => i.id === SummaryHoursLabels.scheduled
    );
    result[SummaryHoursLabels.worked] =
      data?.metrics[workHoursIndex]?.totalDuration || 0;
    result[SummaryHoursLabels.scheduled] =
      data?.metrics[scheduledHoursIndex]?.totalDuration || 0;
    result[SummaryHoursLabels.remaining] =
      result[SummaryHoursLabels.scheduled] - result[SummaryHoursLabels.worked];
    return result;
  }
}
